"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var TwoProductClaims_1 = require("../components/TwoProductClaims/TwoProductClaims");
var targetNode = document.querySelector('.two-product-claims-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(TwoProductClaims_1.default, null), targetNode);
}
